/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CouponEnrollmentLinksViewModel } from "../types/CouponEnrollmentLinksViewModel.ts";
import { couponLinkViewModelSchema } from "./couponLinkViewModelSchema.ts";

export const couponEnrollmentLinksViewModelSchema = z.object({
  couponId: z.optional(z.number().int().describe("ID do cupom.")),
  couponDescription: z.string().describe("Descrição do cupom.").nullish(),
  links: z
    .array(z.lazy(() => couponLinkViewModelSchema))
    .describe("Links de matrícula do cupom, um item por turma vinculada.")
    .nullish(),
}) as unknown as ToZod<CouponEnrollmentLinksViewModel>;
